import { Router } from "@angular/router";
import { TranslocoDirective } from "@jsverse/transloco";
import { Component, inject, OnDestroy, OnInit, signal, WritableSignal } from "@angular/core";
import { SessionStoreRepository } from "../../shared/repositories/session.repository";
import { OverlayLoadingSpinnerBorderComponent } from "../../shared/components/loading/overlay-loading-spinner-border/overlay-loading-spinner-border.component";

@Component({
    selector: "logout",
    templateUrl: "./logout.component.html",
    styleUrls: ["./logout.component.scss"],
    imports: [TranslocoDirective, OverlayLoadingSpinnerBorderComponent]
})
export class LogoutComponent implements OnInit, OnDestroy {
    private readonly sessionStore = inject(SessionStoreRepository);
    private readonly router = inject(Router);

    isLoading: WritableSignal<boolean> = signal(false);

    public ngOnInit() {
        this.redirectOnLogout();
    }

    private redirectOnLogout() {
        this.isLoading.set(true);

        if (this.sessionStore.isLoggedIn() && this.sessionStore.isPatient) {
            this.sessionStore.redirectToStsLogoutPage();
        } else {
            this.router.navigate(["/auth/logged-out"]);
        }
    }

    ngOnDestroy(): void {
        this.isLoading.set(false);
    }
}
